module.exports = __webpack_public_path__ + "static/media/users.ff072288.svg";